import {FC, useEffect, useState} from 'react'
import {BaseModal} from '../../BaseModal/BaseModal'
import {Input} from '../../../../components/Input/Input'
import {Button} from '../../../../components/Button/Button'
import styles from './editGrade.module.css'

type GridTypeResponse = {
  id: number
  name: string
  variation: string
  status?: boolean
}

type Props = {
  onCloseAction: () => void
  title: string
  grids: GridTypeResponse[]
  gradeSelected: {variationId: number; variations: string[]}[]
  setGradeSelected: (grades: {variationId: number; variations: string[]}[]) => void
  selectedGrade: {variationId: number; variations: string[]}
  editPageProduct?: boolean
}

const EditGrade: FC<Props> = ({
  onCloseAction,
  title,
  grids,
  gradeSelected,
  setGradeSelected,
  selectedGrade,
  editPageProduct,
}) => {
  const [gridFound, setGridFound] = useState<GridTypeResponse | null>(null)
  const [variations, setVariations] = useState<string[]>([])
  const [selectedVariations, setSelectedVariations] = useState<Map<string, number>>(new Map())

  useEffect(() => {
    const grid = grids.find((grid) => grid.id === selectedGrade.variationId)
    if (grid) {
      setGridFound(grid)
      const variationsType = JSON.parse(grid.variation || '[]')

      if (Array.isArray(variationsType)) {
        const allVariations = variationsType.sort((a: string, b: string) => a.localeCompare(b))
        // Se editPageProduct for true, filtra as variações para remover as já selecionadas
        const filteredVariations = editPageProduct
          ? allVariations.filter((variation) => !selectedGrade.variations.includes(variation))
          : allVariations
        setVariations(filteredVariations)
      } else if (typeof variationsType === 'object' && variationsType !== null) {
        const values = Object.values(variationsType) as string[]
        const allVariations = values.sort((a, b) => a.localeCompare(b))
        // Se editPageProduct for true, filtra as variações para remover as já selecionadas
        const filteredVariations = editPageProduct
          ? allVariations.filter((variation) => !selectedGrade.variations.includes(variation))
          : allVariations
        setVariations(filteredVariations)
      } else {
        setVariations([])
      }

      const initialSelected = new Map<string, number>()
      selectedGrade.variations.forEach((variation) => {
        initialSelected.set(variation, selectedGrade.variationId)
      })
      setSelectedVariations(initialSelected)
    }
  }, [selectedGrade, grids, editPageProduct])

  const handleVariationClick = (variation: string) => {
    setSelectedVariations((prev) => {
      const newMap = new Map(prev)
      if (newMap.has(variation)) {
        newMap.delete(variation)
      } else {
        newMap.set(variation, selectedGrade.variationId)
      }
      return newMap
    })
  }

  const handleSelectAll = () => {
    if (selectedVariations.size === variations.length) {
      setSelectedVariations(new Map())
    } else {
      const newMap = new Map()
      variations.forEach((variation) => {
        newMap.set(variation, selectedGrade.variationId)
      })
      setSelectedVariations(newMap)
    }
  }

  return (
    <BaseModal onCloseAction={onCloseAction} title={title}>
      <div className={`${styles.modalContent}`}>
        <div className={styles.contentWrapper}>
          {gridFound && (
            <div className='pb-6'>
              <div
                className={`d-flex align-items-center justify-content-between pb-6 ${styles.titleVariation}`}
              >
                <h1 className='m-0 p-0 fs-5'>{gridFound.name}</h1>

                {!editPageProduct && (
                  <p className={`m-0 p-0 fs-8 ${styles.selectAll}`} onClick={handleSelectAll}>
                    {selectedVariations.size === variations.length
                      ? 'Deselecionar tudo'
                      : 'Selecionar tudo'}
                  </p>
                )}
              </div>
              <ul className={`m-0 p-0 pt-2 list-unstyled ${styles.variationList}`}>
                {variations.map((variation: string, index: number) => (
                  <li
                    key={index}
                    className={`${styles.variationItem} ${
                      selectedVariations.has(variation) ? styles.selected : ''
                    }`}
                    onClick={() => handleVariationClick(variation)}
                  >
                    <span>{variation}</span>
                    <input
                      type='checkbox'
                      checked={selectedVariations.has(variation)}
                      onChange={() => {}}
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className={`d-flex justify-content-end pt-6 ${styles.footer}`}>
          <div className='d-flex justify-content-between gap-3 w-100'>
            {!editPageProduct ? (
              <Button
                text='Excluir'
                color='danger'
                size='small'
                horizontalPadding={5}
                btnAttr={{
                  type: 'button',
                }}
                click={() => {
                  const updatedGrades = gradeSelected.filter(
                    (grade) => grade.variationId !== selectedGrade.variationId
                  )
                  setGradeSelected(updatedGrades)
                  onCloseAction()
                }}
                btnClass='fw-bolder'
              />
            ) : (
              <Button
                text='Voltar'
                color='info'
                size='small'
                horizontalPadding={5}
                btnAttr={{
                  type: 'button',
                }}
                click={() => {
                  onCloseAction()
                }}
                btnClass='fw-bolder'
              />
            )}
            <Button
              text='Salvar'
              color='primary'
              size='small'
              horizontalPadding={5}
              btnAttr={{
                type: 'button',
              }}
              click={() => {
                if (selectedVariations.size > 0) {
                  const updatedGrades = gradeSelected.map((grade) => {
                    if (grade.variationId === selectedGrade.variationId) {
                      return {
                        variationId: selectedGrade.variationId,
                        variations: Array.from(selectedVariations.keys()),
                      }
                    }
                    return grade
                  })
                  setGradeSelected(updatedGrades)
                } else {
                  const updatedGrades = gradeSelected.filter(
                    (grade) => grade.variationId !== selectedGrade.variationId
                  )
                  setGradeSelected(updatedGrades)
                }
                onCloseAction()
              }}
              btnClass='fw-bolder'
            />
          </div>
        </div>
      </div>
    </BaseModal>
  )
}

export {EditGrade}
